import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import Select, {Async} from 'react-select';
import LoadingSpinner from '../LoadingSpinner';
import ConditionalBlock from '../ConditionalBlock';
import ErrorMessageContainer from '../ErrorMessageContainer';

export default class DraftBidCreateForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            selectedAccount: null,
            competitions: [],
            selectedCompetition: null,
            suppliers: [],
            selectedSupplier: null,
            errors: [],
        };

        this.onAccountChange = this.onAccountChange.bind(this);
        this.onCompetitionChange = this.onCompetitionChange.bind(this);
        this.onSupplierChange = this.onSupplierChange.bind(this);
        this.loadCompetitions = this.loadCompetitions.bind(this);
        this.loadSuppliers = this.loadSuppliers.bind(this);
        this.onExecuteButtonClick = this.onExecuteButtonClick.bind(this);
    }

    onAccountChange(value) {
        this.setState({
            selectedAccount: value,
            selectedCompetition: null,
            selectedSupplier: null,
        });
    }

    onCompetitionChange(value) {
        this.setState({
            selectedCompetition: value,
            selectedSupplier: null,
        }, () => {
            this.loadSuppliers();
        });
    }

    onSupplierChange(value) {
        this.setState({
            selectedSupplier: value,
        });
    }

    loadCompetitions(searchTerm, callback) {
        const params = {
            account_id: this.state.selectedAccount
                ? this.state.selectedAccount.value
                : null,
            search_term: searchTerm,
        };

        axios
            .get('/draft_bids/competitions', {params})
            .then((response) => {
                callback(null, {options: response.data});
            });
    }

    loadSuppliers() {
        const params = {
            account_id: this.state.selectedAccount
                ? this.state.selectedAccount.value
                : null,
            competition_id: this.state.selectedCompetition
                ? this.state.selectedCompetition.value
                : null,
        };

        this.setState({isLoading: true}, () => {
            axios
                .get('/draft_bids/suppliers', {params})
                .then((response) => {
                    this.setState({
                        isLoading: false,
                        suppliers: response.data,
                    });
                });
        });
    }

    onExecuteButtonClick() {
        const formData = new FormData();

        formData.append('account_id', this.state.selectedAccount
            ? this.state.selectedAccount.value
            : null);
        formData.append('competition_id', this.state.selectedCompetition
            ? this.state.selectedCompetition.value
            : null);
        formData.append('supplier_id', this.state.selectedSupplier
            ? this.state.selectedSupplier.value
            : null);

        this.setState({isLoading: true, errors: []}, () => {
            axios
                .post('/draft_bids/create', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    const id = response.data.id;
                    this.setState({isLoading: false});
                    window.location.href = '/draft_bids/' + id + '/view';
                })
                .catch((failure) => {
                    this.setState({
                        errors: failure.response.data,
                        isLoading: false,
                    });
                });
        });
    }

    render() {
        const {accounts} = window;

        return (
            <div>
                <ErrorMessageContainer errors={this.state.errors}/>

                <div className="form-group">
                    <label htmlFor="account_id" className="col-md-4 control-label">
                        Account*
                    </label>
                    <div className="col-md-8">
                        <Select name="account_id"
                                id="account_id"
                                value={this.state.selectedAccount}
                                options={accounts}
                                clearable={true}
                                placeholder={window.__js_general.choose_literal}
                                onChange={this.onAccountChange}>
                        </Select>
                    </div>
                </div>

                <ConditionalBlock show={this.state.selectedAccount}>
                    <div className="form-group">
                        <label htmlFor="competition_id" className="col-md-4 control-label">
                            {window.__js_general.competition}*
                        </label>
                        <div className="col-md-8">
                            <Async name="competition_id"
                                   id="competition_id"
                                   value={this.state.selectedCompetition}
                                   loadOptions={this.loadCompetitions}
                                   clearable={true}
                                   placeholder={window.__js_general.choose_literal}
                                   cache={false}
                                   onChange={this.onCompetitionChange}>
                            </Async>
                        </div>
                    </div>
                </ConditionalBlock>

                <ConditionalBlock show={this.state.selectedAccount && this.state.selectedCompetition}>
                    <div className="form-group">
                        <label htmlFor="supplier_id" className="col-md-4 control-label">
                            {window.__js_general.supplier}*
                        </label>
                        <div className="col-md-8">
                            <Select name="supplier_id"
                                    id="supplier_id"
                                    value={this.state.selectedSupplier}
                                    options={this.state.suppliers}
                                    clearable={true}
                                    placeholder={window.__js_general.choose_literal}
                                    onChange={this.onSupplierChange}>
                            </Select>
                        </div>
                    </div>
                </ConditionalBlock>

                <div className="form-group">
                    <div className="col-md-offset-4 col-md-8">
                        <button
                            className="btn btn-primary"
                            disabled={this.state.isLoading}
                            onClick={this.onExecuteButtonClick}
                        >
                            <i className="fa fa-fw fa-check"></i> {window.__js_general.execution}
                        </button>
                        {this.state.isLoading ? <LoadingSpinner/> : null}
                    </div>
                </div>
            </div>
        );
    }
}

const element = document.getElementById('draft-bid-create-form');

if (element) {
    ReactDOM.render(<DraftBidCreateForm/>, element);
}